import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import HeaderNavDesktopItem from './HeaderNavDesktopItem';
import HeaderMegaMenuMenu from './HeaderMegaMenuMenu';
import HeaderMegaMenu from './HeaderMegaMenu';
import HeaderContext from './HeaderContext';

function HeaderNavDesktop({ children }) {
  return (
    <nav className="c-header-main-nav  u-show@desktop">
      <ul className="o-list-inline  c-header-main-nav__list  u-margin-bot-none">
        {children}
      </ul>
    </nav>
  );
}

HeaderNavDesktop.Item = HeaderNavDesktopItem;

HeaderNavDesktop.propTypes = {
  children: PropTypes.node.isRequired,
};

HeaderNavDesktop.MegaMenu = function ({ title, children, id }) {
  const { activeMegaMenu, toggleMegaMenu, closeMegaMenu } =
    useContext(HeaderContext);

  function toggle() {
    toggleMegaMenu(id);
  }

  function close() {
    closeMegaMenu(id);
  }

  return (
    <HeaderNavDesktopItem
      title={title}
      onClick={toggle}
      onBlur={close}
      isDropdown
      isActive={id == activeMegaMenu}
    >
      <HeaderMegaMenu isOpen={id == activeMegaMenu}>
        <HeaderMegaMenuMenu
          title={title}
          onClose={toggle}
          isOpen={id == activeMegaMenu}
        >
          {children}
        </HeaderMegaMenuMenu>
      </HeaderMegaMenu>
    </HeaderNavDesktopItem>
  );
};

export default HeaderNavDesktop;
